import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-refund-and-return',
  templateUrl: './refund-and-return.component.html',
  styleUrls: ['./refund-and-return.component.scss'],
  standalone: false
})
export class RefundAndReturnComponent implements OnInit {
  Images = IMAGES
  SupportEmail = SUPPORT_EMAIL;

  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
